// extracted by mini-css-extract-plugin
export var constellationButton = "constellation-button-module--constellationButton--By8kv";
export var constellationButtonGraphic = "constellation-button-module--constellationButtonGraphic--kLbcI";
export var imgWrapper = "constellation-button-module--imgWrapper--Tgfqq";
export var small = "constellation-button-module--small--utrvj";
export var tag = "constellation-button-module--tag--0STsS";
export var timelineItem = "constellation-button-module--timelineItem--UeGXH";
export var title = "constellation-button-module--title--hKnDh";
export var type = "constellation-button-module--type--lG-G9";
export var whiteIcon = "constellation-button-module--whiteIcon--YBsfJ";